import { Component, Inject, HostListener, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { AppState, selectUserTheme } from '@app/core/ngrx';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.addVirtualFileSystem(pdfFonts);
import JsBarcode from 'jsbarcode/bin/JsBarcode';
/**
 * PrintFramePackingSlipDialogComponent
 */
@Component({
  selector: 'ecp-print-frame-packing-slip-dialog',
  templateUrl: './print-frame-packing-slip-dialog.component.html',
  styleUrls: ['./print-frame-packing-slip-dialog.component.scss'],
  standalone: false,
})
export class PrintFramePackingSlipDialogComponent {
  // @select(['user', 'profile', 'theme'])
  public theme$: Observable<string>;
  /**
   * constructor
   * @param {MatDialogRef<PrintFramePackingSlipDialogComponent>} dialogRef
   * @param data
   */
  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<PrintFramePackingSlipDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.theme$ = this.store.pipe(select(selectUserTheme));
  }

  /**
   * closeDialog
   */
  @HostListener('document:keydown.escape')
  closeDialog() {
    this.dialogRef.close();
  }

  textToBase64Barcode(text: string) {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, text, { format: 'CODE128' });
    return canvas.toDataURL('image/png');
  }

  renderPrintOutput(benefitNumber: string, versantFlag: boolean) {
    let waterMarkConfig: { [key: string]: any };
    type Items = {
      image?: string;
      width?: number | string;
      height?: number;
      margin?: number[];
      text?: string;
      style?: string;
      bold?: boolean;
      fontSize?: number;
    }[][];
    const versantORderRow = [
      {
        text: 'Frame Status:',
        fontSize: 8,
        style: 'label',
        width: 100,
      },
      {
        text: 'VERSANT ORDER',
        style: 'value',
        width: '*',
      },
    ];
    let benefitRow = [];
    if (benefitNumber) {
      benefitRow = [
        [
          {
            text: 'Benefit #:',
            fontSize: 8,
            style: 'label',
            // margin: [10, 0, 0, 5],
            width: 100,
          },
          {
            text: this.data?.payload?.benefitNumber,
            fontSize: 8,
            style: 'value',
            // margin: [10, 0, 0, 5],
            width: '*',
          },
        ],
        [
          {
            text: '',
            width: 100,
          },
          {
            image: this.textToBase64Barcode(this.data?.payload?.benefitNumber),
            fontSize: 8,
            width: 100,
            height: 40,
            // margin: [10, 0, 0, 10],
          },
        ],
      ];
    }
    let group1Items: Items = [
      [
        {
          text: '',
          width: 0,
        },
        {
          text: `Lab Name: ${this.data?.payload?.labDetails.name}`,
          bold: true,
          // margin: [10, 0, 0, 10],
          fontSize: 8,
          width: '*',
        },
      ],
      [
        {
          text: '',
          width: 0,
        },
        {
          text: `Account: ${this.data?.payload?.patientDetails?.accountNumber}`,
          bold: true,
          // margin: [10, 0, 0, 10],
          fontSize: 8,
          width: '*',
        },
      ],
      [
        {
          text: '____________________________________________',
          // margin: [10, 0, 0, 10],
          width: 'auto',
          bold: true,
          fontSize: 8,
        },
      ],
      [
        {
          text: 'Order Date:',
          fontSize: 8,
          style: 'label',
          width: 100,
        },
        {
          text: this.data?.payload?.orderDate,
          fontSize: 8,
          style: 'value',
          width: '*',
        },
      ],
      [
        {
          text: 'Order #:',
          fontSize: 8,
          style: 'label',
          width: 100,
        },
        {
          text: this.data?.payload?.orderNumber,
          fontSize: 8,
          style: 'value',
          // margin: [10, 0, 0, 5],
          width: '*',
        },
      ],
      [
        {
          text: '',
          width: 100,
        },
        {
          image: this.textToBase64Barcode(this.data?.payload?.orderNumber),
          fontSize: 8,
          width: 100,
          height: 40,
          // margin: [10, 0, 0, 10],
        },
      ],
    ];
    let group2Items: Items = [
      [
        {
          text: 'Lens Style:',
          fontSize: 8,
          style: 'label',
          // margin: [10, 0, 0, 5],
          width: 100,
        },
        {
          text: [
            this.data?.payload.lensDetails?.lensName || '',
            this.data?.payload.lensDetails?.lensDetail || '',
            this.data?.payload.lensDetails?.color || '',
          ]
            .filter((value) => value !== '')
            .join(','),
          style: 'value',
          width: '*',
        },
      ],
      [
        {
          text: 'Frame Name:',
          style: 'label',
          // margin: [10, 0, 0, 30],
          width: 100,
        },
        {
          text: this.data?.payload?.frameDetails?.name,
          style: 'value',
          width: '*',
        },
      ],
      [
        {
          text: this.data?.payload?.patientDetails?.name,
          style: 'title',
          width: 100,
        },
        {
          text: '',
          style: '',
          width: '*',
        },
      ],
      [
        {
          text: 'Patient Phone #:',
          style: 'label',
          width: 100,
        },
        {
          text: this.data?.payload?.patientDetails?.phoneNumber,
          style: 'value',
          width: '*',
        },
      ],
    ];

    if (benefitNumber && benefitNumber !== 'NO AUTH RE') {
      group1Items = [...group1Items, ...benefitRow];
      if (versantFlag) {
        waterMarkConfig = { text: 'VERSANT ORDER', color: 'red', opacity: 0.3, bold: true, italics: false };
      } else {
        waterMarkConfig = null;
      }
    } else {
      if (versantFlag) {
        waterMarkConfig = { text: 'VERSANT ORDER', color: 'red', opacity: 0.3, bold: true, italics: false };
      } else {
        waterMarkConfig = null;
      }
    }
    if (versantFlag) {
      group1Items.push(versantORderRow);
    }
    return {
      // a string or { width: number, height: number }
      pageSize: 'A5',
      watermark: waterMarkConfig,
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [320, 15, 20, 10],
      pageOrientation: 'landscape',
      content: [...group1Items, ...group2Items].map((item) => ({ columns: item })),
      styles: {
        label: {
          fontSize: 8,
          bold: true,
          // margin: [10, 0, 0, 5]
        },
        value: {
          fontSize: 8,
          // margin: [10, 0, 0, 5]
        },
        title: {
          fontSize: 8,
          bold: true,
          // margin: [10, 0, 0, 5]
        },
      },
      pageBreak: true,
    };
  }

  generatePDF(versantFlag: boolean, benefitNumber?: string) {
    pdfMake.createPdf(this.renderPrintOutput(benefitNumber, versantFlag)).open();
  }
}
